import { render, staticRenderFns } from "./AddBanLinkDialog.vue?vue&type=template&id=1a42b033&scoped=true&"
import script from "./AddBanLinkDialog.vue?vue&type=script&lang=js&"
export * from "./AddBanLinkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a42b033",
  null
  
)

export default component.exports